import React from "react";

export default function Contact ()
{
    return (
        <h1>Inside Contact.js</h1>

    );
}